import React, { Fragment, useEffect, useRef, useState } from "react"
import { GoogleMap, Marker, useLoadScript } from "@react-google-maps/api"
import { toAbsoluteUrl } from "../../../_metronic/_helpers/index.js"
import { ICON_CONSTANTS } from "../../../constants/ImageConstants.js"
import { GoogleMapKey } from "../../../app/helpers/MapHelper.js"
import { MapInfo } from "../MapInfo/index.jsx"
import { INSPECTION_STATUS_ENUM } from "../../../constants/StringConstant.js"

export const PriviewMap = ({
  centroid,
  areas,
  legend,
  legendTitle,
  withStatus,
  infoStyle,
  stroke,
  parse
}) => {
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: GoogleMapKey()
  })
  const mapRef = useRef(null)
  const [center, setCenter] = useState({})
  const [zoom, setZoom] = useState(14)
  const dataMap = []
  const [showInfo, setShowInfo] = useState(false)

  const colorStatus = (status_enum) => {
    switch (status_enum) {
      case INSPECTION_STATUS_ENUM.PASS:
        return "#5EC8F2"
      case INSPECTION_STATUS_ENUM.PARTIAL_PASS:
        return "#F29F05"
      case INSPECTION_STATUS_ENUM.NOT_PASS:
        return "#CC4435"
      default:
        return "#FFFFFF"
    }
  }

  const onMapLoad = (map) => {
    mapRef.current = map
    areas?.map((item, index) => {
      if (!dataMap[index]) {
        dataMap[index] = {
          coordinates: []
        }
      }
      dataMap[index].area_status_enum = item.area_status_enum
      item.coordinates.map((data) => {
        dataMap[index].coordinates.splice(data.seq, 0, {
          seq: data.seq,
          lat: data.lat ?? data.latitude,
          lng: data.lng ?? data.longitude
        })
      })

      const polygon = new google.maps.Polygon({
        paths: parse ? dataMap[index].coordinates : item.coordinates,
        strokeColor: stroke ?? "#353535",
        strokeOpacity: 1,
        strokeWeight: 1,
        fillColor: withStatus
          ? colorStatus(parse ? dataMap[index].area_status_enum : item.area_status_enum)
          : "#CC4435",
        fillOpacity: 0.5
      })
      polygon.setMap(map)
    })
  }

  useEffect(() => {
    if (centroid) {
      setCenter(centroid)
      setZoom(17)
    }
  }, [centroid])

  const handleClick = () => {
    setShowInfo(!showInfo)
  }

  const renderMap = () => {
    return (
      <Fragment>
        {legend && (
          <MapInfo
            show={showInfo}
            data={legend}
            title={legendTitle}
            handleClick={handleClick}
            infoStyle={infoStyle}
          />
        )}
        <GoogleMap
          mapContainerStyle={{
            width: "inherit",
            height: "inherit"
          }}
          zoom={zoom}
          center={center}
          options={{
            disableDefaultUI: true,
            mapTypeId: "satellite"
          }}
          onLoad={(map) => onMapLoad(map)}
          mapTypeId={"satellite"}>
          {areas?.map((item, index) => {
            return (
              <div key={index}>
                <Marker
                  position={item.centroid}
                  label={{
                    text: item.area_name && item.area_name,
                    className: "label-map"
                  }}
                  icon={toAbsoluteUrl(ICON_CONSTANTS.MARKER_TRANSPARENT)}></Marker>
              </div>
            )
          })}
        </GoogleMap>
      </Fragment>
    )
  }
  return isLoaded ? renderMap() : null
}
